import { Component, input, output } from '@angular/core'
import { TableHeaderSortIndicatorComponent } from '../table-header-sort-indicator/table-header-sort-indicator.component'
import { CurrentSort, SortEvent } from '../../services/table-sort.service'

@Component({
  imports: [TableHeaderSortIndicatorComponent],
  selector: 'button[app-table-header-sort-button]',
  host: {
    '(click)': 'sort($event)',
    '[class.not-sortable]': '!sortable()',
  },
  template: `
      <span class="header-name">{{ label() }}</span>
      <span app-table-header-sort-indicator [currentSort]="currentSort()"></span>
  `,
  styles: `
    :host {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1.5rem);
      align-items: center;
      background-color: transparent;
      border: none;
      padding: 0;
      gap: 0.25rem;
      white-space: nowrap;
      
      &.not-sortable {
        cursor: default
      }
    }

    .header-name {
      white-space: break-spaces;
      text-align: start;
      text-overflow: ellipsis;
      overflow: hidden;
      max-height: 2.5rem;
      line-height: 1.2rem;
    }
  `,
})
export class TableHeaderSortButtonComponent {
  label = input.required<string>()
  field = input.required<string>()
  sortable = input.required<boolean>()
  currentSort = input.required<CurrentSort | undefined>()
  sortChange = output<SortEvent>()

  sort(evt: MouseEvent) {
    if (this.sortable()) {
      this.sortChange.emit({
        name: this.field(),
        multi: evt.ctrlKey,
      })
    }
  }
}
